export default function(formElement) {
    const form = formElement
    if (!form) {
        return;
    }

    let formLocationWord = form.querySelector('input[name="location"]');
    let formLat = form.querySelector('input[name="lat"]');
    let formLng = form.querySelector('input[name="lng"]');

    const locationHandler = new CustomerLocationHandler({
        element: form,
    });

    if (formLat && formLng) {
        locationHandler.onLocationUpdate(function(response) {
            formLat.value = response.lat;
            formLng.value = response.lng;
        });

        // If there's no lat/lng on first load, check if we have one in local storage and use it if so, otherwise blank the location input
        if (formLat.value == '' || formLng.value == '') {
            if (locationHandler.locationKnown()) {
                formLocationWord.value = locationHandler.postcode();
                formLat.value = locationHandler.lat();
                formLng.value = locationHandler.lng();
            } else {
                formLocationWord.value = '';
                formLat.value = '';
                formLng.value = '';
            }
        }
    }

    form.addEventListener('submit', function(e) {
        // If we're still waiting for a response from the geocoder, change the geocoder completed callback to submit form after it completes
        if (locationHandler.waitingForGeocoder == true) {
            form.querySelector('button[type="submit"]').classList.add('input-processing');
            locationHandler.onLocationUpdate(function(response) {
                if (formLat && formLng) {
                    formLat.value = response.lat;
                    formLng.value = response.lng;
                }
                $(form).submit();
            });
            e.preventDefault();
            return false;
        }

        return true;
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/dealer-locators/find-dealer-search-box.js